import { Activity } from "lucide-react";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  compact?: boolean;
  className?: string;
}

export default function Logo({ size = "md", compact = false, className = "" }: LogoProps) {
  const sizes = {
    sm: { icon: 20, text: "text-lg" },
    md: { icon: 28, text: "text-2xl" },
    lg: { icon: 36, text: "text-3xl" },
  };
  const { icon, text } = sizes[size];

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="bg-novacare-700 text-white rounded-lg p-1.5 shadow-sm shrink-0">
        <Activity className="w-5 h-5" style={{ width: icon, height: icon }} />
      </div>
      {!compact && (
        <span className={`${text} font-bold tracking-tight text-novacare-900`}>NovaCare</span>
      )}
    </div>
  );
}
